exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".vue-daterange-picker[data-v-b42d8124] {\n  width: 100%;\n  display: block;\n}\n.reportrange-text[data-v-b42d8124] {\n@apply d-flex align-content-center;\n}", ""]);

